<template lang="pug">
ui-stage
  ui-admin-table(
    module-url='/admin/monitor-viewers',
    :data='data',
    :attributes='attributes',
    :with-create='true',
    :with-edit='true',
    :with-delete='true',
    stripe
  )
    template(v-slot:column_lastLoginAt='{ row }')
      span {{ formatDateTime(row.lastLoginAt) }}

    template(v-slot:column_allowedProjects='{ row }')
      span {{ getProjectsText(row.allowedProjects) }}
</template>

<script>
import { adminList } from '@yishitec/web/mixins';

export default {
  name: 'MonitorViewersList',
  mixins: [adminList],
  data() {
    return {
      projects: [],
    };
  },
  async mounted() {
    await this.loadProjects();
  },
  methods: {
    async loadProjects() {
      try {
        const res = await this.api('/api/projects/list', {
          state: 'ACTIVE',
        })();
        this.projects = res.list || [];
      } catch (e) {
        console.error('加载项目列表失败', e);
      }
    },

    getProjectsText(allowedProjects) {
      if (!allowedProjects) return '无';

      try {
        const projectIds = JSON.parse(allowedProjects);
        if (!Array.isArray(projectIds) || !projectIds.length) return '无';

        const projectNames = projectIds.map((id) => {
          const project = this.projects.find((p) => p.id == id);
          return project ? project.title : `项目${id}`;
        });

        return projectNames.join(', ');
      } catch (e) {
        return '格式错误';
      }
    },
  },
};
</script>
